import { render, staticRenderFns } from "./generateCustomerNumber.vue?vue&type=template&id=2ed53b33"
import script from "./generateCustomerNumber.ts?vue&type=script&lang=js&external"
export * from "./generateCustomerNumber.ts?vue&type=script&lang=js&external"
import style0 from "./generateCustomerNumber.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports